// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "baggagePage__newBaggage-3lE-M";
export { _1 as "__esModule", _2 as "baggagePage__newBaggage" }
export default { "__esModule": _1, "baggagePage__newBaggage": _2 }
